export const EXTENDED_CAUSES_LOADED = 'EXTENDED_CAUSES_LOADED';
export const TRENDS_FILTERS_LOADED = 'TRENDS_FILTERS_LOADED';
export const GLOBAL_IMPACT_FILTERS_LOADED = 'GLOBAL_IMPACT_FILTERS_LOADED';
export const BREAKDOWN_FILTERS_LOADED = 'BREAKDOWN_FILTERS_LOADED';
export const FACTS_FILTERS_LOADED = 'FACTS_FILTERS_LOADED';
export const GLOBAL_YLL_DATA_LOADED = 'GLOBAL_YLL_DATA_LOADED';
export const COUNTRIES_LOADED = 'COUNTRIES_LOADED';
